export const determineEntityType = (_meilisearch_id: string) => {
  if (_meilisearch_id.startsWith("individual-")) {
    return "individual";
  } else if (_meilisearch_id.startsWith("payment-")) {
    return "payment";
  } else if (_meilisearch_id.startsWith("mda-")) {
    return "mda";
  } else if (_meilisearch_id.startsWith("agency-")) {
    return "agency";
  } else if (_meilisearch_id.startsWith("government-request-")) {
    return "government-request";
  } else {
    return "unknown";
  }
};
